<template>
    <div>
        <q-card class="shadow-0" style="max-height: 100vh; overflow-y: auto;">
            <q-card-section class="row justify-between">
                <div class="text-h6">Datos del Domicilio</div>
                <q-btn outline icon="save" label="Guardar" color="primary" class="q-mr-sm"
                    @click="guardarDatosFiscales()" />
            </q-card-section>

            <q-separator />

            <q-card-section>
                <div class="row q-col-gutter-md">
                    <div class="col-12">
                        <q-input dense outlined v-model="datos.cp" label="Código Postal" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="datos.estado" label="Estado" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="datos.municipio" label="Municipo / Alcaldía" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="datos.localidad" label="Localidad" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="datos.colonia" label="Colonia o Barrio" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="datos.calle" label="Calle" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="datos.numExterior" label="Número Exterior" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="datos.numInterior" label="Número Interior" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="datos.indicaciones" label="Indicaciones adicionales" />
                    </div>
                </div>
            </q-card-section>

            <q-card-actions align="right">
            </q-card-actions>
        </q-card>
    </div>
</template>

<script>
import { QSpinnerClock } from 'quasar'
import axios from 'axios'

export default {
    name: 'DatosGenerales',
    data() {
        return {
            datos: {
                _id: '',
                _id_cliente: '',
                cp: '',
                estado: '',
                municipio: '',
                localidad: '',
                colonia: '',
                calle: '',
                numExterior: '',
                numInterior: '',
                indicaciones: '',
            }
        };
    },
    computed: {
        usuarioStore() {
            return this.$store.state.auth.clienteStore;
        },
    },
    methods: {
        async guardarDatosFiscales() {
            if (this.datos.cp == '' || this.datos.estado == '' || this.datos.municipio == '' || this.datos.localidad == '' || this.datos.colonia == '' || this.datos.calle == '' || this.datos.numExterior == '') {
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'Ingrese todos los datos del formulario.' })
                return
            }
            this.datos._id_cliente = this.usuarioStore._id_cliente
            console.log(this.datos)
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando información. Espere...', messageColor: 'white' })
            try {
                await axios.post('Configuracion/PostDomicilio', this.datos)
                this.$q.loading.hide()

                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Datos guardados correctamente' })
            } catch (err) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'Error al actualizar perfil' })
            }
        },
        async obtenerPerfil() {
            try {
                const res = await axios.get('Configuracion/GetDomicilioPorCliente/' + this.usuarioStore._id_cliente)

                if (res.data) {
                    this.datos = res.data
                }
                console.log('res.data', res.data)
            } catch (err) {
                console.error('Error al obtener perfil:', err)
            }
        },
    },
    mounted() {
        this.obtenerPerfil()
    },
};
</script>